import { connect } from "react-redux";
import AccountSetting from "../components/AccountSetting/AccountSetting";
import * as actions from "../redux/actions/AccountSetting";
import { postUsersUpdatePassword } from "../redux/actions/ResetPassword";

import * as selector from "../redux/selectors/accountSettingSelector";
import { replace, push } from "react-router-redux";
import { AccountSettingDirectory, ChildAccountSettingDirectory } from "../constants/ComponentTypes";

const mapStateToProps = (state) => {
  return {
    user: selector.getUser(state),
    message: state.accountSetting.message,
    isSaved: state.accountSetting.isSaved,
    isSaving: state.accountSetting.isSaving,
    error: state.accountSetting.error,
    isLoading: selector.getIsLoading(state),
    routerInfo: state.router.location,
    errorMessage: state.accountSetting.errorMessage,
    shortMessage: state.accountSetting.shortMessage,
    senders: state.accountSetting.senders.toIndexedSeq().toArray(),
    isLoadingSenders: state.accountSetting.isLoadingSenders,
    isDeleting: state.accountSetting.isDeleting,
    isDeletingChildUser: state.accountSetting.isDeletingChildUser,
    isSavingChildUser: state.accountSetting.isSavingChildUser,
    type: (() => {
      switch (state.router.location.pathname) {
        case AccountSettingDirectory.GENERAL.path:
          return AccountSettingDirectory.GENERAL.value;
        case AccountSettingDirectory.PLANS.path:
          return AccountSettingDirectory.PLANS.value;
        case AccountSettingDirectory.INTEGRATIONS.path:
          return AccountSettingDirectory.INTEGRATIONS.value;
        // 支払いタブは非表示のため、URLを直接指定された場合も基本タブを表示する
        default:
          return AccountSettingDirectory.GENERAL.value;
      }
    })(),
    childAccountType: (() => {
      switch (state.router.location.pathname) {
        case ChildAccountSettingDirectory.ACCOUNT_LIST.path:
          return ChildAccountSettingDirectory.ACCOUNT_LIST.name;
        case ChildAccountSettingDirectory.AUTHORITY.path:
          return ChildAccountSettingDirectory.AUTHORITY.name;
        case ChildAccountSettingDirectory.OWNER.path:
        case AccountSettingDirectory.GENERAL.path:
        case AccountSettingDirectory.PLANS.path:
        case AccountSettingDirectory.BILLING.path:
        case AccountSettingDirectory.INTEGRATIONS.path:
          return ChildAccountSettingDirectory.OWNER.name;
        default:
          return ChildAccountSettingDirectory.ACCOUNT_LIST.name;
      }
    })(),
    orderContacts: state.accountSetting.orderContacts.toIndexedSeq().toArray(),
    isLoadingOrderContacts: state.accountSetting.isLoadingOrderContacts,
    isLoadingMails: state.accountSetting.isLoadingMails,
    mails: state.accountSetting.mails.toIndexedSeq().toArray(),
    childUsers: state.accountSetting.childUsers.toIndexedSeq().toArray(),
    childUser: selector.getChildUser(state),
    isLoadingChildUser: state.accountSetting.isLoadingChildUser,
    isProxyLoginLoading: state.accountSetting.isProxyLoginLoading,
    proxyLoggedIn: state.accountSetting.proxyLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUserInfo() {
    dispatch(actions.getUser());
  },

  setUserInfo(user) {
    dispatch(actions.patchUser(user));
  },

  removeCrm(id) {
    dispatch(actions.removeCrm(id));
  },

  deleteAccount() {
    dispatch(actions.deleteUser());
  },

  updatePaymentInfo(info) {
    dispatch(actions.putUsersMePayment(info));
  },

  postPaymentInfo(info) {
    dispatch(actions.postUsersMePayment(info));
  },

  updateRouterState(newState) {
    dispatch(replace(`/setting`, newState));
  },

  getSenders() {
    dispatch(actions.getSenders());
  },

  postSender(data) {
    dispatch(actions.postSender(data));
  },

  deleteSender(id) {
    dispatch(actions.deleteSender(id));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getOrderContacts() {
    dispatch(actions.getOrderContacts());
  },

  postOrderContacts(data) {
    dispatch(actions.postOrderContacts(data));
  },

  deleteOrderContacts(id) {
    dispatch(actions.deleteOrderContacts(id));
  },

  getUserMails() {
    dispatch(actions.getUserMails());
  },

  postUserMails(data) {
    dispatch(actions.postUserMails(data));
  },

  deleteUserMailsById(id) {
    dispatch(actions.deleteUserMailsById(id));
  },

  putUserMails(id, data) {
    dispatch(actions.putUserMails(id, data));
  },

  patchUsersEmailNotificationFlag(data) {
    dispatch(actions.patchUsersEmailNotificationFlag(data));
  },

  postUsersUpdatePassword(data) {
    dispatch(postUsersUpdatePassword(data));
  },

  getChildUsers(data) {
    dispatch(actions.getChildUsers(data));
  },

  getChildUserById(id) {
    dispatch(actions.getChildUserById(id));
  },

  postChildUser(data) {
    dispatch(actions.postChildUser(data));
  },

  putChildUsersAuthority(data) {
    dispatch(actions.putChildUsersAuthority(data));
  },

  patchChildUserAuthorityById(id, data) {
    dispatch(actions.patchChildUserAuthorityById(id, data));
  },

  deleteChildAccount(id, data) {
    dispatch(actions.deleteChildUser(id, data));
  },

  getProxyLoginChildUser(id) {
    dispatch(actions.getProxyLoginChildUser(id));
  },

  getProxyLoginParentUser() {
    dispatch(actions.getProxyLoginParentUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSetting);



// WEBPACK FOOTER //
// ./src/containers/AccountSetting.js